module.exports = __webpack_public_path__ + "img/9X.ac4a3808.png";